<template>
    <page>
        <div class="shadow-25" v-if="form">
            <v-header :title="$metaInfo.title" icon="face"/>
            <card width="100%">

                <form @submit.prevent="onSubmit"
                      class="row gutter-xs"
                      @keydown="form.onKeydown($event)">

                    <v-input path="firstname"
                             v-model="form.firstname"
                             :label="$T('first name')"
                             :form="form"
                             class="col-md-4 col-sm-6 col-xs-12">
                    </v-input>

                    <v-input path="lastname"
                             v-model="form.lastname"
                             :label="$T('last name')"
                             :form="form"
                             class="col-md-4 col-sm-6 col-xs-12">
                    </v-input>

                    <v-datetime path="birthdate"
                                v-model="form.birthdate"
                                :label="$T('birth date')"
                                :form="form"
                                :max="maxBirthDate"
                                class="col-md-4 col-sm-6 col-xs-12">
                    </v-datetime>


                    <v-input path="email"
                             v-model="form.email"
                             :label="$T('email')"
                             :form="form"
                             class="col-md-4 col-sm-6 col-xs-12">
                    </v-input>


                    <v-input path="phone"
                             v-model="form.phone"
                             :label="$T('phone')"
                             :form="form"
                             class="col-md-4 col-sm-6 col-xs-12">
                    </v-input>


                    <v-input path="zipcode"
                             v-model="form.zipcode"
                             :label="$T('zip code')"
                             :form="form"
                             class="col-md-4 col-sm-6 col-xs-12">
                    </v-input>

                    <v-input path="referer"
                             v-model="form.referer"
                             :label="$t('referer code')"
                             :form="form"
                             class="col-md-4 col-sm-6 col-xs-12">
                    </v-input>

                    <!-- Submit Button -->
                    <div class="col-12 row justify-center q-mt-md">
                        <v-button outline
                                  :label="$T('save')"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  :loading="form.busy"
                                  type="submit">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>
                    </div>
                </form>
            </card>
        </div>
    </page>
</template>

<script>
    import Form from "vform";
    import moment from "moment";
    import {QSpinnerPuff} from "quasar-framework";
    import {mapGetters} from 'vuex';
    import consumerModel from '../consumerModel'

    export default {
        middleware: "auth",

        mixins: [consumerModel],

        metaInfo() {
            return {title: this.$T("consumer registration")};
        },

        components: {
            QSpinnerPuff
        },

        data() {
            return {
                form: null,
                genderOptions: [
                    {value: 1, label: this.$T("gender male")},
                    {value: 0, label: this.$T("gender female")}
                ]
            };
        },

        mounted() {
            this.form = new Form(this.consumerModel)
        },

        computed: {
            ... mapGetters({
                user: 'auth/user'
            }),

            maxBirthDate() {
                return moment()
                    .subtract(18, "years")
                    .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            }
        },

        methods: {
            async onSubmit() {
                this.form.loose = true

                await this.form.post(`${window.config.appUrl}/api/v1/consumer`)
                    .then(({data}) => {
                        this.form = new Form(this.consumerModel);

                        this.$q.dialog({
                            title: this.$T('success'),
                            message: data.success.message,
                            preventClose: true,
                            color: 'primary',
                            stackButtons: true,
                            ok: {
                                label: `${this.$T("ok")}`,
                            }
                        }).then(() => {
                            this.$router.push({name: 'home'})
                        }).catch(() => {
                        })
                    })
                    .catch(({response}) => {
                        this.$q.dialog({
                            title: this.$T("error"),
                            message: response.data.message,
                            preventClose: true,
                            color: "negative",
                            ok: {
                                label: `${this.$T("ok")}`
                            }
                        })
                    })
            }
        }
    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/call-center/consumer-registration.vue